import styled from "styled-components"
import Overlay from "../../Overlay"
import Modal from "../../Utils/Modal"
import { useState } from "react"

import { BiLoaderAlt } from "react-icons/bi";

import useApi from "../../../hooks/useApi";
const TituloModal = styled.h2`
    font-size: 18px;
    margin: 5px 0 0 0;
    color: #000;
`
const SubtituloModal = styled.p`
    font-size: 14px;
    margin: 5px 0 0 0;
    color: #0000006a;
`
const ContainerBotoes = styled.div`
    width: 100%;
    height: 40px;
    margin-top: 20px;
    display: flex;
    justify-content: space-between;
`
const Botao = styled.button`
    width: calc( 50% - 5px );
    height: 100%;
    border: none;
    border-radius: 8px;
    box-sizing: border-box;
    &.cancel{
        background: #fff;
        border: 2.5px solid #ccc;
        color: #ccc;
        font-weight: bold;
    }
    &.delete {
        background: #d64343;
        color: white;
        font-weight: bold;
    }
    cursor: pointer;
    transition: .3s;
    &:hover{
        scale: 1.04;
    }
`
const IconLoader = styled(BiLoaderAlt)`
    animation: spin 1s linear infinite;
    width: 20px;
    height: 20px;
    margin: 0;
    @keyframes spin {
        from {
            transform: rotate(0deg);
        }
        to {
            transform: rotate(360deg);
        }
    }
`

const ModalDeleteTrGHE = ({ item, fecharModal, atualizarValues }) => {
    const api = useApi();


    const [loading, setLoading] = useState(false);

    const handleDelete = async () => {

        setLoading(true);

        try {
            const { data } = await api.post('/Painel/API/InfoPanel/DeleteTreinamentoGHE/', {
                id: item.ID
            });

            console.log(data);
            await atualizarValues();
            fecharModal();
        } catch (error) {
            console.log(error);
        } finally {
            setLoading(false);
        }

    }

    return (
        <>
            <Overlay state={true} >
                <Modal size="sm" >
                    <TituloModal>Excluir Treinamento GHE</TituloModal>
                    <SubtituloModal>Tem certeza que deseja excluir este treinamento?</SubtituloModal>
                    <ContainerBotoes>
                        <Botao className="cancel" onClick={fecharModal}>Cancelar</Botao>
                        <Botao className="delete" onClick={handleDelete} >
                            { loading ? <IconLoader /> : 'Excluir' }
                        </Botao>
                    </ContainerBotoes>
                </Modal>
            </Overlay>
        </>
    )
}

export default ModalDeleteTrGHE;